/** Copyright (c) 2019 T. Rowe Price. All rights reserved. */

import './PreferencesBreadCrumbs.scss';

import { arrayOf, shape, string } from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

import { ReactComponent as Arrow } from 'assets/icons/arrow.svg';
import { ReactComponent as ChevronLeft } from 'assets/icons/chevron-left.svg';
import { getPreferencesBreadcrumbs } from 'state/preferences/PreferencesSelectors';
import { isMobile } from 'state/view/ViewSelectors';

const PreferencesBreadCrumbs = ({
  links,
  isDesktopLayout,
  isBackPath,
  backPath,
  isMobile
}) => {
  const crumbsLength = 2;
  const crumbsClassName = 'preferences-bread-crumbs';

  if (isMobile) {
    return null;
  }

  return (
    <div className={crumbsClassName} data-metrics-location="BRD">
      {isDesktopLayout ? (
        links.length > crumbsLength ? (
          <Link className="preferences-bread-crumb-label" to={'/profile'}>
            <Arrow />
            <span className="preferences-bread-crumb-back-to-profile">
              Back to Profile & Settings
            </span>
          </Link>
        ) : (
          null
        )
      ) : (
        !isBackPath && (
          <Link className="mobile-back-link" to={backPath}>
            <div className="mobile-back-icon-container">
              <ChevronLeft className="mobile-back-icon" />
              Back
            </div>
          </Link>
        )
      )}
    </div>
  );
};

PreferencesBreadCrumbs.propTypes = {
  links: arrayOf(
    shape({
      label: string.isRequired,
      url: string.isRequired
    })
  ).isRequired
};

const mapStateToProps = (state) => ({
  links: getPreferencesBreadcrumbs(state),
  isDesktopLayout: state.view.isDesktopLayout,
  isMobile: isMobile(state)
});

export default withRouter(connect(mapStateToProps)(PreferencesBreadCrumbs));
